import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutContent from './components/AboutContent';
import TeamSection from './components/TeamSection';
import ValuesSection from './components/ValuesSection';
import StatsSection from './components/StatsSection';
import { useSEO, getOrganizationSchema, getBreadcrumbSchema } from '../../utils/seo';

export default function About() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Hakkımızda Isparta Yıldız & Başyiğit Hukuk Danışmanlık',
    description: 'Yıldız & Başyiğit Hukuk ve Danışmanlık olarak Isparta merkezinde 4+ yıldır hukuki danışmanlık hizmetleri sunuyoruz. Deneyimli avukat kadromuz ile ticaret hukuku, gayrimenkul hukuku, aile hukuku ve ceza hukuku alanlarında müvekkillerimize profesyonel ve güvenilir çözümler üretiyoruz. Müvekkil memnuniyeti odaklı yaklaşımımızla hukuki süreçlerinizde yanınızdayız.',
    keywords: 'hukuk bürosu hakkında, Isparta avukat, hukuk danışmanlığı deneyim, profesyonel hukuk hizmeti',
    ogImage: 'https://public.readdy.ai/ai/img_res/997e90113b56a0607f2b2c20dd74c538.jpg',
    canonical: `${siteUrl}/about`,
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        getOrganizationSchema(),
        getBreadcrumbSchema([
          { name: 'Ana Sayfa', url: siteUrl },
          { name: 'Hakkımızda', url: `${siteUrl}/about` }
        ]),
        {
          '@type': 'AboutPage',
          '@id': `${siteUrl}/about#aboutpage`,
          url: `${siteUrl}/about`,
          name: 'Hakkımızda - Yıldız & Başyiğit Hukuk ve Danışmanlık',
          description: 'Isparta merkezinde profesyonel hukuki danışmanlık hizmetleri sunan deneyimli ekibimiz hakkında bilgi edinin'
        }
      ]
    }
  });

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutContent />
        <TeamSection />
        <ValuesSection />
        <StatsSection />
      </main>
      <Footer />
    </div>
  );
}
